import { render, staticRenderFns } from "./ItemImage.vue?vue&type=template&id=1a28743e&scoped=true"
import script from "./ItemImage.vue?vue&type=script&lang=js"
export * from "./ItemImage.vue?vue&type=script&lang=js"
import style0 from "./ItemImage.vue?vue&type=style&index=0&id=1a28743e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a28743e",
  null
  
)

export default component.exports